import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  TimeZoneConvertPipe,
  TimeDateFormatPipe,
  CustomDateFormatPipe,
  TimeFormatPipe,
  FullTimeDateFormatPipe
} from './timezone.pipe';
import {
  CelisusToFarenhietFormatPipe,
  FarenhietToCelisusFormatPipe,
  ExtensionFormatPipe,
  EncryptFormatPipe,
  DecryptFormatPipe,
  CheckTimeGreaterFormatPipe,
  AgeFormatPipe,
  StringtoReplacePipe,
  ReplaceTrimsterFormatPipe,
  TruncatePipe,
  ReplacePipe
} from './common.pipe';



@NgModule({
  declarations: [
    TimeZoneConvertPipe,
    TimeDateFormatPipe,
    CustomDateFormatPipe,
    CelisusToFarenhietFormatPipe,
    FarenhietToCelisusFormatPipe,
    ExtensionFormatPipe,
    EncryptFormatPipe,
    DecryptFormatPipe,
    TimeFormatPipe,
    CheckTimeGreaterFormatPipe,
    FullTimeDateFormatPipe,
    AgeFormatPipe,
    StringtoReplacePipe,
    ReplaceTrimsterFormatPipe,
    TruncatePipe,
    ReplacePipe
  ],
  imports: [
    CommonModule
  ],
  exports: [
    TimeZoneConvertPipe,
    TimeDateFormatPipe,
    CustomDateFormatPipe,
    CelisusToFarenhietFormatPipe,
    FarenhietToCelisusFormatPipe,
    ExtensionFormatPipe,
    EncryptFormatPipe,
    DecryptFormatPipe,
    TimeFormatPipe,
    CheckTimeGreaterFormatPipe,
    FullTimeDateFormatPipe,
    AgeFormatPipe,
    StringtoReplacePipe,
    ReplaceTrimsterFormatPipe,
    TruncatePipe,
    ReplacePipe
  ]
})
export class PipesModule { }
